import { h, Component } from 'preact';
import { Header } from '@cube/blocks';
import { FinanceSpinner } from '../glyphs';
import { getBalanceSheet } from '@os/cloudquote';
import { CurrencyIndicator } from '../currency-indicator';
import style from './style';
import { Text } from 'preact-i18n';

const INTL_NS = 'stock-data-table';
const INTL_NS_BS = 'balanceSheet';

import StockDataTable from './index';

export default class BalanceSheet extends Component {

	componentWillMount() {
		getBalanceSheet(this.props.symbol).then((data) => this.setState({ data }));
	}

	render({ timespan, ...props }, { data }) {
		let rows = data && data.rows;

		if (!rows || !rows.length) {
			return (
				<FinanceSpinner />
			);
		}

		return (
			<div>
				<Header class={style.dataHeader}
					title={<Text id={`${INTL_NS}.${INTL_NS_BS}.balanceSheet`} />}
					secondary={<Text id={`${INTL_NS}.${INTL_NS_BS}.numInMs`} />}
				>
					<CurrencyIndicator symbol={props.symbol} />
				</Header>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_BS}.periodEnding`} />}
					showDates
					cols={[]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_BS}.currAssets`} />}
					cols={[
						{
							name: 'Cash and Cash Equivalents',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.cash`} />
						},
						{
							name: 'Short Term Investments',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.investST`} />
						},
						{
							name: 'Accounts Receivable',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.aR`} />
						},
						{
							name: 'Prepaid Expenses',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.prepaidExp`} />
						},
						{
							name: 'Inventory',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.inventory`} />
						},
						{
							name: 'Other Current Assets',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.otherCurrAssets`} />
						},
						{
							name: 'Current Assets',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.currAssets`} />
						},
						{
							name: 'Long Term Investments',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.investLT`} />
						},
						{
							name: 'Net Property, Plant and Equipment',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.netPPE`} />
						},
						{
							name: 'Goodwill and Intangibles',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.goodWill`} />
						},
						{
							name: 'Other Non-Current Assets',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.otherNonCurrAssets`} />
						},
						{
							name: 'Long Term Receivables',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.receivablesLT`} />
						},
						{
							name: 'Total Assets',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.totalAssets`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_BS}.currLiab`} />}
					cols={[
						{
							name: 'Accounts Payable',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.aP`} />
						},
						{
							name: 'Other Current Liabilities',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.otherCurrLiab`} />
						},
						{
							name: 'Accrued Liabilities and Other Payables',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.accruedLiab`} />
						},
						{
							name: 'Short Term Debt',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.debtST`} />
						},
						{
							name: 'Current Portion of Long Term Debt',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.debtCurrentLT`} />
						},
						{
							name: 'Current Liabilities',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.currLiab`} />,
							bold: true
						},
						{
							name: 'Long Term Debt',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.debtLT`} />
						},
						{
							name: 'Other Non-Current Liabilities',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.otherNonCurrLiab`} />
						},
						{
							name: 'Total Liabilities',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.totalLiab`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_BS}.shareHoldersEquity`} />}
					cols={[
						{
							name: 'Common Stock',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.commonStock`} />
						},
						{
							name: 'Preferred Stock',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.preferredStock`} />
						},
						{
							name: 'Retained Earnings',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.retainedEarnings`} />
						},
						{
							name: 'Treasury Stock',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.treasuryStock`} />
						},
						{
							name: 'Additional Paid-In Capital',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.addlPIC`} />
						},
						{
							name: 'Accumulated Other Comprehensive Income',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.accumIncome`} />
						},
						{
							name: 'Other Equity',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.otherEquity`} />
						},
						{
							name: 'Total Equity',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_BS}.totalEquity`} />,
							bold: true
						}
					]}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/stock-data-table/balance-sheet.js